var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 2.33314H2.33317C2.02375 2.33314 1.72701 2.45606 1.50821 2.67485C1.28942 2.89364 1.1665 3.19039 1.1665 3.49981V11.6665C1.1665 11.9759 1.28942 12.2726 1.50821 12.4914C1.72701 12.7102 2.02375 12.8331 2.33317 12.8331H10.4998C10.8093 12.8331 11.106 12.7102 11.3248 12.4914C11.5436 12.2726 11.6665 11.9759 11.6665 11.6665V7.58314M10.7915 1.45814C11.0236 1.22608 11.3383 1.0957 11.6665 1.0957C11.9947 1.0957 12.3094 1.22608 12.5415 1.45814C12.7736 1.6902 12.9039 2.00495 12.9039 2.33314C12.9039 2.66133 12.7736 2.97608 12.5415 3.20814L6.99984 8.74981L4.6665 9.33314L5.24984 6.99981L10.7915 1.45814Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f7e139c8b92b2453f2b960daeeabcc78.svg";
export { ForwardRef as ReactComponent };